import React, { useState, useEffect, Fragment } from "react";
import $ from "jquery";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CustomDatePicker from "components/CustomInput/CustomDatePicker.js";
import CustomSelect from "components/CustomInput/CustomSelect";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import ExpandLessOutlinedIcon from "@material-ui/icons/ExpandLessOutlined";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import Table from "components/Table/Table.js";
import Titulo1 from "components/Typography/Titulo1.js";
import Collapse from "@material-ui/core/Collapse";

import { API_URI, formatDate } from '../../helpers';

// Helper robusto para fechas cross-browser (Safari compatible)
function parseDateString(dateStr) {
  if (!dateStr) return null;
  // YYYY-MM-DD
  let match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }
  // DD-MM-YYYY
  match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(dateStr);
  if (match) {
    return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
  }
  return new Date(dateStr); // fallback
}

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Rubik','Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);

export default function FormStudents(props) {
  
  const [openSusc, setOpenSusc] = useState(true);
  const [lastSubsEnd, setLastSubsEnd] = useState(null); // Fecha fin de última suscripción activa

  const [cfg, setCfg] = useState({
    countries: [],
    plans: [],
    methods: [],
    status: [],
    prices:{}
  });

  function handleSubmit(event) {
    event.preventDefault();
    const data = new FormData();
    const aux = {};
    Object.keys(inputs).forEach(function(k) {
      if ($("#" + k).length > 0) {
        if ("validity" in $("#" + k)[0] && !$("#" + k)[0].validity.valid) {
          aux[k] = true;
        }
      }
      data.append(k, inputs[k]);
    });
    
    if (Object.keys(aux).length > 0) {
      setErrors({
        ...errors,
        ...aux
      });
      $("#" + Object.keys(aux))[0].focus();
      return false;
    }

    //https://18.215.96.2/api
    fetch(`${API_URI}/admin/student/save`, {
      method: "POST",
      body: data
    })
      .then((res)=>{
        if(res.status != 200){
          alert( "No se ha podido procesar tu solicitud. Reintenta más tarde por favor!");
          return false
        }
        return res.json()
      })
      .then(result => {
        if (result.result) {
          if (!inputs.studentId) {
            // Es un nuevo alumno, actualizar ID y recalcular campos de suscripción
            setInpunts({
              ...inputs,
              ["studentId"]: result.insert_id
            });
            
            // Recalcular fechas y medio de pago según el país del alumno
            const countryId = inputs.studentCountry;
            if (countryId && cfg.countries) {
              const country = cfg.countries.find(c => c.value == countryId);
              const duration = getDuration(countryId, cfg.plans[0].value);
              const now = new Date();
              const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
              const end = new Date(start.getTime());
              end.setDate(end.getDate() + duration);
              
              let defaultMethod = cfg.methods[0].value;
              if (country && country.pay_channels && country.pay_channels.length > 0) {
                defaultMethod = country.pay_channels[0];
              }
              
              const newSuscData = {
                studentSuscPlan: cfg.plans[0].value,
                studentSubsStart: formatDate(start),
                studentSubsEnd: formatDate(end),
                studentSuscMethod: defaultMethod,
                studentSuscCountry: countryId
              };
              setInitSuscript(newSuscData);
              setInputSucription(newSuscData);
            }
          } else {
            props.history.push("/admin/Students");
          }
        }else{
          alert( "No se ha podido procesar tu solicitud. Reintenta más tarde por favor!");
        }
      });
  }

  const [initSuscript, setInitSuscript] = useState({
    studentSuscPlan: "",
    studentSubsStart: null,
    studentSubsEnd: null,
    studentSuscMethod: "",
    studentSuscCountry: "",
    studentSuscPrice: "",
  });

  const [inputs, setInpunts] = useState({
    studentName: "",
    studentLastname: "",
    studentEmail: "",
    studentCountry: "",
    studentState:"",
    studentId: false,
  });

  const [inputSuscription, setInputSucription] = useState(initSuscript);

  const errorsInit = {
    studentName: false,
    studentLastname: false,
    studentEmail: false,
    studentCountry: false,
    studentId: false,
    studentState:false,
    studentSuscPlan: false,
    studentSubsStart: false,
    studentSubsEnd: false,
    studentSuscMethod: false,
    studentSuscCountry: false,
  };

  const [errors, setErrors] = useState(errorsInit);

  useEffect(() => {
    if (props.match.params.studentId) {
      fetch(
        `${API_URI}/admin/student/get/` +
          parseInt(props.match.params.studentId)
      )
        .then(res => res.json())
        .then(result => {
          const data = {
            studentName: result.name,
            studentLastname: result.lastname,
            studentEmail: result.mail,
            studentCountry: result.country_id,
            studentState: result.state,
            studentId: result.id
          };

          setInpunts(data);
          getSuscriptions(result.id);

          initSuscript.studentSuscCountry = result.country_id;
          setInitSuscript(initSuscript);

          inputSuscription.studentSuscCountry = result.country_id;
          setInputSucription(inputSuscription);
        });
    }
    getCfg();
  }, [props.match.params.studentId]);

  async function getCfg() {
    const resp = await fetch(
      `${API_URI}/admin/student/cfg`
    );
    const json = await resp.json();

    setCfg(json);
    
    const countryId = inputSuscription.studentSuscCountry;
    const country = countryId ? json.countries.find(c => c.value == countryId) : null;
    
    // Usar duración de promo si existe, sino usar duración del plan
    let duration = parseInt(json.plans[0].duration, 10) || 365;
    if (country && country.active_promo_duration) {
      duration = parseInt(country.active_promo_duration, 10);
    }
    
  // Usar siempre formato seguro para Safari
  const now = new Date();
  const safeToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const endDate = new Date(safeToday.getTime());
  endDate.setDate(endDate.getDate() + duration);

    // Obtener medio de pago default para el país del estudiante
    let defaultMethod = json.methods[0].value;
    if (country && country.pay_channels && country.pay_channels.length > 0) {
      defaultMethod = country.pay_channels[0];
    }

    const data = {
      studentSuscPlan: json.plans[0].value,
  studentSubsStart: formatDate(safeToday),
  studentSubsEnd: formatDate(endDate),
      studentSuscMethod: defaultMethod,
      studentSuscCountry: inputSuscription.studentSuscCountry
    };

    setInitSuscript(data);
    setInputSucription(data);
  }

  // Efecto para actualizar fechas cuando se obtiene la última suscripción
  useEffect(() => {
    // Parse and apply last subscription end date robustly (accepts DD-MM-YYYY, DD/MM/YYYY, YYYY-MM-DD)
    function parseDateString(dstr){
      if(!dstr) return null;
      // Already ISO
      const isoMatch = dstr.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if(isoMatch){
        return new Date(parseInt(isoMatch[1],10), parseInt(isoMatch[2],10)-1, parseInt(isoMatch[3],10));
      }
      // DD-MM-YYYY or DD/MM/YYYY
      const dmMatch = dstr.match(/^(\d{1,2})[\-/](\d{1,2})[\-/](\d{4})$/);
      if(dmMatch){
        return new Date(parseInt(dmMatch[3],10), parseInt(dmMatch[2],10)-1, parseInt(dmMatch[1],10));
      }
      // Fallback: intentar YYYY-MM-DD seguro para Safari
      const ymd = dstr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (ymd) {
        return new Date(parseInt(ymd[1],10), parseInt(ymd[2],10)-1, parseInt(ymd[3],10));
      }
      // Fallback a Date constructor (último recurso)
      const dt = new Date(dstr);
      if(!isNaN(dt.getTime())) return dt;
      return null;
    }

    if (lastSubsEnd && cfg.plans && cfg.plans.length > 0) {
      let startDateObj = parseDateString(lastSubsEnd);
      if (!startDateObj) return; // can't parse

      // Si la suscripción ya venció, usar hoy como fecha de inicio
      const now2 = new Date();
      const safeToday2 = new Date(now2.getFullYear(), now2.getMonth(), now2.getDate());
      if (startDateObj < safeToday2) {
        startDateObj = safeToday2;
      }

      const countryId = inputSuscription.studentSuscCountry;
      const country = countryId ? cfg.countries.find(c => c.value == countryId) : null;

      // Usar duración de promo si existe, sino usar duración del plan
      let duration = parseInt(cfg.plans[0].duration, 10) || 365;
      if (country && country.active_promo_duration) {
        duration = parseInt(country.active_promo_duration, 10);
      }

  // Siempre clonar usando componentes para Safari
  const endDateObj = new Date(startDateObj.getFullYear(), startDateObj.getMonth(), startDateObj.getDate());
  endDateObj.setDate(endDateObj.getDate() + duration);

      setInputSucription(prev => ({
        ...prev,
        studentSubsStart: formatDate(startDateObj),
        studentSubsEnd: formatDate(endDateObj)
      }));
      
      setInitSuscript(prev => ({
        ...prev,
        studentSubsStart: formatDate(startDateObj),
        studentSubsEnd: formatDate(endDateObj)
      }));
    }
  }, [lastSubsEnd, cfg]);

  function submithWithSubs(event) {
    event.preventDefault();
    const data = new FormData();
    const aux = {};
    Object.keys(inputSuscription).forEach(function(k) {
      if ($("#" + k).length > 0) {
        if ("validity" in $("#" + k)[0] && !$("#" + k)[0].validity.valid) {
          aux[k] = true;
        }
      }
      data.append(k, inputSuscription[k]);
    });
    data.append('studentId', inputs.studentId);
    if (Object.keys(aux).length > 0) {
      setErrors({
        ...errors,
        ...aux
      });
      $("#" + Object.keys(aux))[0].focus();
      return false;
    }

    fetch(`${API_URI}/admin/suscriptions/save`, {
      method: "POST",
      body: data
    })
      .then((res)=>{
        if(res.status != 200){
          alert( "No se ha podido procesar tu solicitud. Reintenta más tarde por favor!");
          return false
        }
        return res.json()
      })
      .then(result => {
        if (result.result) {
          setInputSucription(initSuscript);
          getSuscriptions();
          //props.history.push("/admin/Students");
        }else{
          alert( "No se ha podido procesar tu solicitud. Reintenta más tarde por favor!");
        }
      });
  }

  function handleChanges(event) {
    const name = event.target.id;
    setInpunts({
      ...inputs,
      [name]: event.target.value
    });
  }

  // Función auxiliar para calcular duración según país y plan
  function getDuration(countryId, planId) {
    const country = cfg.countries.find(c => c.value == countryId);
    const plan = cfg.plans.find(p => p.value == planId);
    
    // Si hay promo vigente para el país, usar esa duración
    if (country && country.active_promo_duration) {
      return parseInt(country.active_promo_duration, 10);
    }
    
    // Si no hay promo, usar la duración del plan
    if (plan && plan.duration) {
      return parseInt(plan.duration, 10);
    }
    
    return 365; // default
  }

  function handleChangesSusc(event) {
    const name = event.target.id;
    const value = event.target.value;
    
    let newState = {
      ...inputSuscription,
      [name]: value
    };

    // Si cambia el país, auto-seleccionar el medio de pago default y recalcular fechas
    if (name === 'studentSuscCountry' && value) {
      const country = cfg.countries.find(c => c.value == value);
      if (country && country.pay_channels && country.pay_channels.length > 0) {
        newState.studentSuscMethod = country.pay_channels[0];
      }
      
      // Recalcular fechas desde hoy con la duración del nuevo país
      const duration = getDuration(value, inputSuscription.studentSuscPlan || cfg.plans[0].value);
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const end = new Date(start.getTime());
      end.setDate(end.getDate() + duration);
      newState.studentSubsStart = formatDate(start);
      newState.studentSubsEnd = formatDate(end);
    }

    // Si cambia el plan o la fecha de inicio, auto-calcular fecha de fin
    if (name === 'studentSuscPlan' || name === 'studentSubsStart') {
      const planId = name === 'studentSuscPlan' ? value : inputSuscription.studentSuscPlan;
      const startDate = name === 'studentSubsStart' ? value : inputSuscription.studentSubsStart;
      const countryId = inputSuscription.studentSuscCountry;
      
      if (planId && startDate && countryId) {
        const duration = getDuration(countryId, planId);
        const start = parseDateString(startDate) || new Date();
        const end = new Date(start.getTime());
        end.setDate(end.getDate() + duration);
        newState.studentSubsEnd = formatDate(end);
      }
    }

    // Si cambia país o plan, recalcular el precio default (sin pisar la edición
    // manual una vez que el operador tipea en la casilla de precio).
    if (name === 'studentSuscCountry' || name === 'studentSuscPlan') {
      const c = name === 'studentSuscCountry' ? value : inputSuscription.studentSuscCountry;
      const p = name === 'studentSuscPlan' ? value : inputSuscription.studentSuscPlan;
      if (c && p && cfg && cfg.prices && cfg.prices[c] && cfg.prices[c][p]) {
        newState.studentSuscPrice = cfg.prices[c][p].price || '';
      }
    }

    setInputSucription(newState);
  }

  const [tableStructure, setTableStructure] = useState({
    headers:[{name:"Tipo",type:"text"},{name:"Inicio",type:"text"},{name:"Vencimiento",type:"text"},{name:"Medio de pago",type:"text"},{name:"Monto",type:"text"},{name:"Pais",type:"text"},{name:"Moneda",type:"text"},{name:"Anular",type:"text"}],
    data:[]
  })
  
  
  function getPrice() {
    if(inputSuscription.studentSuscCountry && inputSuscription.studentSuscCountry!="" && inputSuscription.studentSuscPlan!='' && cfg){
      return cfg.prices[inputSuscription.studentSuscCountry][inputSuscription.studentSuscPlan].price || '';
    }
    return '';
  }

  function getCoin(){
    if(inputSuscription.studentSuscCountry && inputSuscription.studentSuscCountry!="" && cfg && cfg.countries.length > 0 ){
      return cfg.countries.find(elem => elem.value==inputSuscription.studentSuscCountry).coin_cod || '';
    }
    return '';
  }

  async function cancelSubscription(id){
    const response = await fetch(`${API_URI}/admin/suscriptions/cancel/`+id);
    const json = await response.json();
    if(json.result){
      getSuscriptions();
    }else{
      alert( "No se ha podido procesar tu solicitud. Reintenta más tarde por favor!");
    }
  }

  async function getSuscriptions(id){
    var currentId = id ? id : inputs.studentId;
    const response = await fetch(`${API_URI}/admin/suscriptions/`+currentId);
    const json = await response.json();
    const data = [];
    
    // Buscar la suscripción activa más reciente (no cancelada)
    let latestActiveEnd = null;
    json.forEach((elem,k) => {
      // Si no está cancelada y tiene fecha de fin
      if (!elem.cancel && elem.end) {
        const endDate = new Date(elem.end);
        if (!latestActiveEnd || endDate > new Date(latestActiveEnd)) {
          latestActiveEnd = elem.end;
        }
      }
      
      data.push([
        {name:elem.plan.name,type:'text',cfg:{inactive:elem.cancel}},
        {name:elem.start,type:"text"},
        {name:elem.end,type:"text"},
        {name:elem.pay_channel ? elem.pay_channel.name : "", type:"text"},
        {name:elem.price,type:"text"},
        {name:elem.country.name,type:"text"},
        {name:elem.country.coin_cod,type:"text"},
        {name:"Anular",type:'link',to:'',action:()=>{cancelSubscription(elem.id)}},
      ])
    })
    
    // Guardar la fecha de fin de la última suscripción
    setLastSubsEnd(latestActiveEnd);
    
    setTableStructure({
      ...tableStructure,
      ['data']:data
    })
  }

  return (
    <div>
      <GridContainer>
        <GridItem
          xs={12}
          sm={12}
          md={7}
          style={{ marginTop: "-90px", zIndex: "1040" }}
        >
          <Titulo1>Añadir nuevo alumno</Titulo1>
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <form>
            <Card>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Nombre del alumno"
                      id="studentName"
                      value={inputs.studentName}
                      error={errors.studentName}
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true
                      }}
                      onChange={handleChanges}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Apellido del alumno"
                      id="studentLastname"
                      formControlProps={{
                        fullWidth: true
                      }}
                      value={inputs.studentLastname}
                      error={errors.studentLastname}
                      onChange={handleChanges}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomSelect
                      options={cfg.countries}
                      id="studentCountry"
                      value={inputs.studentCountry}
                      onChange={handleChanges}
                      error={errors.studentCountry}
                      label="País"
                      required={true}
                      name="paisSubsc"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={9}>
                    <CustomInput
                      labelText="E-mail"
                      id="studentEmail"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        type: "email"
                      }}
                      value={inputs.studentEmail}
                      error={errors.studentEmail}
                      onChange={handleChanges}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomSelect
                        options={cfg.status}
                        id="studentState"
                        value={inputs.studentState}
                        error={errors.studentState}
                        required={true}
                        onChange={handleChanges}
                        label="Estado"
                        name="stateId"
                    />
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ marginTop: "48px" }}
                  >
                    {!inputs.studentId ? (
                      <Button color="info" onClick={handleSubmit}>
                        Añadir alumno
                      </Button>
                    ) : (
                      <div>
                        <Button color="info" onClick={handleSubmit}>
                          Actualizar alumno
                        </Button>
                      </div>
                    )}
                  </GridItem>
                </GridContainer>
                {inputs.studentId ? (
                  <GridContainer style={{ paddingTop: "24px" }}>
                    <GridItem xs={12} sm={12} md={12}>
                      <span 
                        style={{cursor:'pointer'}}
                        onClick={() => {
                              getSuscriptions()
                              setErrors(errorsInit);
                              setInputSucription(initSuscript);
                              setOpenSusc(!openSusc);
                            }}>
                        <Titulo1>
                          Suscripciones{" "}
                          {openSusc ? (
                            <ExpandLessOutlinedIcon
                              color="info"
                            
                            />
                          ) : (
                            <ExpandMoreOutlinedIcon
                              color="info"
                              
                            />
                          )}
                        </Titulo1>
                      </span>
                      
                    </GridItem>
                  </GridContainer>
                ) : (
                  ""
                )}
                <Collapse in={openSusc}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomSelect
                          options={cfg.countries}
                          id="studentSuscCountry"
                          value={inputSuscription.studentSuscCountry}
                          required={true}
                          error={errors.studentSuscCountry}
                          onChange={handleChangesSusc}
                          label="País"
                          name="paisSubsc"
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomSelect
                        options={cfg.plans}
                        label="Suscripción"
                        id="studentSuscPlan"
                        onChange={handleChangesSusc}
                        required={true}
                        error={errors.studentSuscPlan}
                        value={inputSuscription.studentSuscPlan}
                        name="suscriptionType"
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={3}>
                      <CustomDatePicker
                        formControlProps={{
                          fullWidth: true
                        }}

                        required={true}
                        error={errors.studentSubsStart}
                        value={inputSuscription.studentSubsStart}
                        id="studentSubsStart"
                        onChange={handleChangesSusc}
                        label="Fecha de Inicio"
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={3}>
                      <CustomDatePicker
                        formControlProps={{
                          fullWidth: true
                        }}
                        value={inputSuscription.studentSubsEnd}
                        required={true}
                        error={errors.studentSubsEnd}
                        id="studentSubsEnd"
                        onChange={handleChangesSusc}
                        label="Fecha de Vencimiento"
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                          labelText={"precio "+getCoin()}
                          id="studentSuscPrice"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            type:'number',
                            min: 0,
                            step: '0.01',
                            // Fondo blanco (no el gris "read-only" por defecto): el precio es
                            // editable y así matchea los selects País/Plan/Pago de la misma fila.
                            style: { backgroundColor: '#fff' },
                            inputProps: { style: { backgroundColor: '#fff' } }
                          }}
                          onChange={handleChangesSusc}
                          value={inputSuscription.studentSuscPrice !== '' && inputSuscription.studentSuscPrice != null ? inputSuscription.studentSuscPrice : getPrice()}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomSelect
                          options={cfg.methods}
                          id="studentSuscMethod"
                          value={inputSuscription.studentSuscMethod}
                          onChange={handleChangesSusc}
                          required={true}
                          error={errors.studentSuscMethod}
                          label="Pago"
                          name="medioPago"
                      />
                    </GridItem>


                  </GridContainer>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ marginTop: "48px" }}
                  >
                    {inputs.studentId ? (
                      <Button color="info" onClick={submithWithSubs}>
                        Actualizar y Renovar Suscripción
                      </Button>
                    ) : (
                      ""
                    )}
                  </GridItem>
                    
                    
                  <GridItem
                  xs={12}
                  sm={12}
                  md={12}>
                    <Table
                      tableHeaderColor="info"
                      tableHead={tableStructure.headers}
                      tableData={tableStructure.data}
                    />
                  </GridItem>
                </Collapse>
              </CardBody>
            </Card>
          </form>
        </GridItem>

        
      </GridContainer>
    </div>
  );
}
